// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './axios'
import './assets/less/main.less'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import  jquery from 'jquery'
import { library } from '@fortawesome/fontawesome-svg-core'
import {faNewspaper,faCubes} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VideoPlayer from 'vue-video-player'

library.add(faNewspaper,faCubes)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(ElementUI, {size: 'small'})
Vue.use(VideoPlayer)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  jquery,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js